<template>

    <section id="new_ref_fifth_step" class="flex">


        <titlePage>
            <template slot="titleBody">
                <div class="hero-head has-text-centered" >
                    <h1 class="title has-text-weight-light is-size-1 ">{{ currentPosition.name }}</h1>
                    <h2 class="associated_ref_name">{{ $t('modules.positions.formStep6.associatedRef') }} : <span>{{ getRefName(associatedRef) }}</span></h2>
                </div>
            </template>
        </titlePage>

        <div class="hero subsection_container">
            <div class="hero-body">
                <div class="container mini-container bottom-section has-text-centered">
                    <h2 class="title is-size-1 has-text-weight-bold stepTitle">
                        {{ $t('modules.positions.formStep6.title') }}
                    </h2>
                    <h3 class="subtitle email_notice" >
                        {{ $t('modules.positions.formStep6.notice') }}
                    </h3>
                    <div class="campaign_block" v-if="currentPosition.is_campaign">
                        <h3 class="subtitle email_notice">
                            {{ $t('modules.positions.formStep6.campaign_notice') }}
                        </h3>
                        <div class="campaign_link" >
                            {{campaignLink}}
                        </div>
                    </div>
                    <!-- <button @click="sendEval">save</button> -->
                </div>
            </div>
            <div class="hero-foot">
                <div class="container mini-container bottom-section">

                    <div class="bottom_btn_container evals_actions">
                        <btnUnderline link="/positions">
                            <span v-html="$t('modules.positions.formStep6.buttonBack')" ></span>
                        </btnUnderline>
                        <!-- <btnUnderline :link="'/positions/' + currentPosition.id ">Modifier<br> ce poste</btnUnderline> -->
                        <btnUnderline @actionClick="reinitNew">
                            <span v-html="$t('modules.positions.formStep6.buttonNew')" ></span>
                        </btnUnderline>
                    </div>

                </div>
            </div>
        </div>



    </section>

</template>

<script>
import titlePage from "@/components/layouts/titlePage"

export default {
    name: 'formEvalStep6',
    components: {
        titlePage
    },
    data(){
        return {
            createdEval: {},
            campaignLink: ""
        }
    },
    mounted(){
        this.$store.dispatch('PositionStore/createPosition').then(data => {
            this.campaignLink = data.campaign_link


        })
    },
    computed: {
        currentPosition(){
            return this.$store.state.PositionStore.currentPosition
        },
        associatedRef(){
            return this.$store.state.PositionStore.associatedRef
        }
    },
    methods: {
        getRefName(refItem){
            return refItem.job_titles[this.$i18n.locale]
        },
        reinitNew(){
            this.$store.dispatch('PositionStore/initNew')
        }
    }
}

</script>

<style lang="scss" >
#new_ref_fifth_step{
    background: $white;

    display: flex;
    flex-direction: column;
    .subsection_container{
        background: $white;
        .hero-body{
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 100px;
            .stepTitle{
                max-width: 500px;
                text-align: center;
            }
        }
    }
    .bottom_btn_container{
        display: flex;
        justify-content: space-around;
    }
    .evals_actions{
        .btn_underline{
            width: 240px;
        }
    }
    .email_notice{
        margin-top: 20px;
        max-width: 500px;
        margin: 20px auto 0;
        color: $grey;
    }
}
.campaign_link{
    background: #e7eaee;
    padding: 8px;
    margin-top: 28px;
}
</style>